<template>
  <van-popup
    v-model:show="visible"
    round
    class="profile-popup-overlay"
    @click-overlay="close"
  >
    <div class="profile-instructions">
      <div class="instructions-header">
        <span class="header-side" aria-hidden="true"></span>
        <span class="instructions-title">{{ t('download.pwaDownloadInstructions') }}</span>
        <button type="button" class="close-btn" aria-label="Close" @click="close">✕</button>
      </div>
      <div class="instructions-scroll">
        <img
          v-for="(src, index) in stepImages"
          :key="index"
          :src="src"
          :alt="`Step ${index + 1}`"
          class="step-image"
        />
      </div>
      <div class="instructions-footer">
        <van-button class="download-btn" block @click="onDownload">
          {{ t('system.download') }}
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { computed, ref, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  download: [];
}>();

const { t, locale } = useI18n();
const visible = ref(false);

const stepImages = computed(() => {
  const suffix = locale.value === 'pt' ? '' : '_en';
  return [1, 2, 3, 4, 5, 6, 7].map((n) => `/static/home/step${n}${suffix}.jpg`);
});

const open = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

const onDownload = () => {
  close();
  emit('download');
};

defineExpose({ open, close });
</script>

<style scoped>
.profile-popup-overlay {
  width: 85%;
  max-width: calc(100vw - 32px);
  height: 85vh;
  background: transparent;
  overflow: hidden;
  box-sizing: border-box;
}

.profile-instructions {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
  width: 100%;
  background: #f2f2f4;
  border: 1px solid #dadce0;
  border-radius: 12px;
  padding: 12px;
  color: #202124;
  overflow: hidden;
  box-sizing: border-box;
}

.instructions-header {
  display: grid;
  grid-template-columns: 0px 1fr 24px;
  align-items: center;
  column-gap: 4px;
  flex-shrink: 0;
  padding-bottom: 10px;
  z-index: 2;
}

.header-side {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.instructions-title {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.35;
  margin: 0;
  min-width: 0;
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 18px;
  color: #000;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
}

.instructions-scroll {
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-inline: 2px;
  scrollbar-gutter: stable;
}

.step-image {
  width: 100%;
  display: block;
  border-radius: 8px;
  margin: 0 auto 10px;
}

.step-image:last-child {
  margin-bottom: 0;
}

.instructions-footer {
  flex-shrink: 0;
  padding-top: 10px;
  z-index: 2;
}

.download-btn {
  border-radius: 10px;
  height: 38px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #007AFF;
  background: #007AFF;
  color: #fff;
}
</style>
